// import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../app/shared/components/header/header.component';
import { OverviewComponent } from '../booking/components/overview/overview.component';
import { OverviewContainerComponent } from '../../app/shared/components/overview-container/overview-container.component';
import { LoginComponent } from '../../app/shared/components/login/login.component';
import { LoginOtpComponent } from '../../app/shared/components/login-otp/login-otp.component';
import { EmailCheckComponent } from '../../app/shared/components/email-check/email-check.component';
import { LoginDisplayComponent } from '../../app/shared/components/login-display/login-display.component';
import { SetPasswordComponent } from '../../app/shared/components/set-password/set-password.component';
import { LocationPlacesLookupComponent } from '../../app/shared/components/location-places-lookup/location-places-lookup.component';
import { LocationResidentialLookupComponent } from '../../app/shared/components/location-residential-lookup/location-residential-lookup.component';
import { LocationHotelBusinessLookupComponent } from '../../app/shared/components/location-hotel-business-lookup/location-hotel-business-lookup.component';
import { NotificationsComponent } from '../../app/shared/components/notifications/notifications.component';
import { ModalComponent } from '../../app/shared/components/modal/modal.component';
import { ProductInfoComponent } from '../../app/shared/components/product-info/product-info.component';
import { AutoTabDirective } from '../../app/shared/directives/auto-tab.directive';
import { RevealToggleDirective } from '../../app/shared/directives/reveal-toggle.directive';
import { RevealContentDirective } from '../../app/shared/directives/reveal-content.directive';
import { ClickOutsideDirective } from '../../app/shared/directives/click-outside.directive';
import { AutoFocusDirective } from '../../app/shared/directives/auto-focus.directive';
import { FormatCardDirective } from '../../app/shared/directives/format-card.directive';
import { AdminFiltersComponent } from '../../app/shared/components/admin-filters/admin-filters.component';
import { FlightResultsComponent } from '../../app/shared/components/flight-results/flight-results.component';
import { FlightDetailsComponent } from '../../app/shared/components/flight-details/flight-details.component';
import { BookingDetailsNotesComponent } from '../../app/shared/components/booking-details-notes/booking-details-notes.component';
import { BookingDetailsTrickyComponent } from '../../app/shared/components/booking-details-tricky/booking-details-tricky.component';
import { BookingDetailsExcessComponent } from '../../app/shared/components/booking-details-excess/booking-details-excess.component';
import { BookingDetailsDoorStepComponent } from '../../app/shared/components/booking-details-door-step/booking-details-door-step.component';
import { PriceBreakdownComponent } from '../../app/shared/components/price-breakdown/price-breakdown.component';
import { PageLoaderComponent } from '../../app/shared/components/page-loader/page-loader.component';
import { TranslationLoaderComponent } from './components/translation-loader/translation-loader.component';
import { MomentModule } from 'ngx-moment';
import { CheckEmptyDirective } from '../../app/shared/directives/check-empty.directive';
import { PromoComponent } from '../../app/shared/components/promo/promo.component';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
// import { TooltipModule } from 'ng2-tooltip';

// Popper
import { TooltipComponent } from '../../app/shared/components/tooltip/tooltip.component';
import { DatepickerComponent } from '../../app/shared/components/datepicker/datepicker.component';

// modal components
import { ModalBaseComponent } from '../../app/shared/components/modal-v2/modal-base/modal-base.component';
import { ModalFlightDirectionComponent } from '../../app/shared/components/modal-v2/modal-flight-direction/modal-flight-direction.component';
import { BookingDetailsTimeslotsComponent } from '../../app/shared/components/booking-details-timeslots/booking-details-timeslots.component';
import { BookingDetailsExcessPaymentComponent } from '../../app/shared/components/booking-details-excess-payment/booking-details-excess-payment.component';
import { BookingDetailsExcessDisplayComponent } from '../../app/shared/components/booking-details-excess-display/booking-details-excess-display.component';
import { ModalFlightSearchComponent } from '../../app/shared/components/modal-v2/modal-flight-search/modal-flight-search.component';
import { BookingDetailsDoorStepDisplayComponent } from '../../app/shared/components/booking-details-door-step-display/booking-details-door-step-display.component';
import { BookingDetailsDoorStepPaymentComponent } from '../../app/shared/components/booking-details-door-step-payment/booking-details-door-step-payment.component';
import { ModalProductTypeComponent } from '../../app/shared/components/modal-v2/modal-product-type/modal-product-type.component';
import { LanguageSelectorComponent } from '../../app/shared/components/language-selector/language-selector.component';
import { BookingDetailsCustomsPaymentComponent } from './components/booking-details-customs-payment/booking-details-customs-payment.component';
import { BookingDetailsCustomsComponent } from './components/booking-details-customs/booking-details-customs.component';
import { BookingDetailsCustomsDisplayComponent } from './components/booking-details-customs-display/booking-details-customs-display.component';
import { TrustPilotComponent } from './components/trust-pilot/trust-pilot.component';
import { TrustPilotReviewsComponent } from './components/trust-pilot-reviews/trust-pilot-reviews.component';
import { FlightInfoComponent } from './components/modal-v2/flight-info/flight-info.component';
import { RemoveServiceModalComponent } from './components/modal-v2/remove-service-modal/remove-service-modal.component';
import { ModalTimeSlotExpiredComponent } from './components/modal-v2/modal-time-slot-expired/modal-time-slot-expired.component';
import { AssociatedFlightsComponent } from './components/modal-v2/associated-flights/associated-flights.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';
import { BookingItemLoaderComponent } from './components/booking-item-loader/booking-item-loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PostOfficeLookupComponent } from './components/post-office-lookup/post-office-lookup.component';
import { ModalAddPasswordComponent } from './components/modal-v2/modal-add-password/modal-add-password.component';
import { HubdropInfoComponent } from './components/modal-v2/hubdrop-info/hubdrop-info.component';
import { SavePereferencesModalComponent } from './components/modal-v2/save-pereferences-modal/save-pereferences-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    MomentModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    // TooltipModule,
  ],
  declarations: [
    HeaderComponent,
    OverviewComponent,
    OverviewContainerComponent,
    LoginComponent,
    LoginOtpComponent,
    EmailCheckComponent,
    LoginDisplayComponent,
    SetPasswordComponent,
    NotificationsComponent,
    LocationPlacesLookupComponent,
    LocationResidentialLookupComponent,
    LocationHotelBusinessLookupComponent,
    ModalComponent,
    ProductInfoComponent,
    AutoTabDirective,
    RevealToggleDirective,
    RevealContentDirective,
    ClickOutsideDirective,
    AutoFocusDirective,
    FormatCardDirective,
    AdminFiltersComponent,
    BookingDetailsNotesComponent,
    BookingDetailsTrickyComponent,
    BookingDetailsExcessComponent,
    BookingDetailsDoorStepComponent,
    FlightResultsComponent,
    FlightDetailsComponent,
    PriceBreakdownComponent,
    PageLoaderComponent,
    TranslationLoaderComponent,
    TooltipComponent,
    DatepickerComponent,
    ModalBaseComponent,
    ModalFlightDirectionComponent,
    BookingDetailsTimeslotsComponent,
    CheckEmptyDirective,
    BookingDetailsExcessPaymentComponent,
    BookingDetailsExcessDisplayComponent,
    PromoComponent,
    ModalFlightSearchComponent,
    BookingDetailsDoorStepDisplayComponent,
    BookingDetailsDoorStepPaymentComponent,
    ModalProductTypeComponent,
    LanguageSelectorComponent,
    BookingDetailsCustomsPaymentComponent,
    BookingDetailsCustomsComponent,
    BookingDetailsCustomsDisplayComponent,
    TrustPilotComponent,
    TrustPilotReviewsComponent,
    FlightInfoComponent,
    RemoveServiceModalComponent,
    ModalTimeSlotExpiredComponent,
    AssociatedFlightsComponent,
    AccordionComponent,
    NoDataFoundComponent,
    BookingItemLoaderComponent,
    PostOfficeLookupComponent,
    LoginOtpComponent,
    ModalAddPasswordComponent,
    HubdropInfoComponent,
    SavePereferencesModalComponent,
  ],
  exports: [
    HeaderComponent,
    OverviewComponent,
    OverviewContainerComponent,
    LoginComponent,
    LoginOtpComponent,
    EmailCheckComponent,
    LoginDisplayComponent,
    SetPasswordComponent,
    NotificationsComponent,
    LocationPlacesLookupComponent,
    LocationResidentialLookupComponent,
    LocationHotelBusinessLookupComponent,
    ModalComponent,
    ModalBaseComponent,
    ModalFlightDirectionComponent,
    ProductInfoComponent,
    AutoTabDirective,
    RevealToggleDirective,
    RevealContentDirective,
    ClickOutsideDirective,
    AutoFocusDirective,
    FormatCardDirective,
    BookingDetailsNotesComponent,
    BookingDetailsTrickyComponent,
    BookingDetailsExcessComponent,
    BookingDetailsDoorStepComponent,
    FlightResultsComponent,
    FlightDetailsComponent,
    PriceBreakdownComponent,
    PageLoaderComponent,
    TranslationLoaderComponent,
    TooltipComponent,
    DatepickerComponent,
    BookingDetailsTimeslotsComponent,
    CheckEmptyDirective,
    BookingDetailsExcessPaymentComponent,
    BookingDetailsExcessDisplayComponent,
    BookingDetailsDoorStepDisplayComponent,
    BookingDetailsDoorStepPaymentComponent,
    PromoComponent,
    ModalProductTypeComponent,
    LanguageSelectorComponent,
    BookingDetailsCustomsPaymentComponent,
    BookingDetailsCustomsComponent,
    BookingDetailsCustomsDisplayComponent,
    TrustPilotComponent,
    TrustPilotReviewsComponent,
    FlightInfoComponent,
    RemoveServiceModalComponent,
    ModalTimeSlotExpiredComponent,
    AssociatedFlightsComponent,
    AccordionComponent,
    BookingItemLoaderComponent,
    NoDataFoundComponent,
    BookingItemLoaderComponent,
    PostOfficeLookupComponent,
    LoginOtpComponent,
    ModalAddPasswordComponent,
    SavePereferencesModalComponent
  ]
})
export class SharedModule { }
